import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("dsf-icon-button", {
  slot: "anchor",
  dsf_icon: "HelpCircle",
  dsf_size: "small"
}, null, -1 /* HOISTED */)
const _hoisted_2 = { class: "dsf-p-m max-w-380 flex w-[calc(100vw-9.2rem)]" }
const _hoisted_3 = { class: "flex flex-col dsf-hidden-mobile" }
const _hoisted_4 = {
  dsf_level: "s-semibold",
  class: "dsf-mb-xs"
}
const _hoisted_5 = { class: "dsf-mb-m" }
const _hoisted_6 = ["dsf_href"]
const _hoisted_7 = { class: "flex flex-col dsf-hidden-tablet dsf-hidden-desktop" }
const _hoisted_8 = {
  dsf_level: "xs-semibold",
  class: "dsf-mb-xs"
}
const _hoisted_9 = {
  dsf_level: "xs",
  class: "dsf-mb-m"
}
const _hoisted_10 = ["dsf_href"]
const _hoisted_11 = { dsf_level: "xs" }

import { analytics } from '@/services/analyticsProvider'

const email = 'shipper-portal@sennder.com'
const feedbackLink = 'https://form.jotform.com/sennder/shipper-portal-feedback'


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpCenter',
  setup(__props) {

function handleOpenChanged({ detail: open }: CustomEvent<boolean>) {
  if (open) {
    analytics.trackShellEvent('click/icon-help-center')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-popover", {
    dsf_offset_vertical: 14,
    dsf_placement: "bottom-end",
    onOpenChanged: handleOpenChanged
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("dsf-text", _hoisted_4, _toDisplayString(_ctx.$t('helpCenter.title')), 1 /* TEXT */),
        _createElementVNode("dsf-text", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.$t('helpCenter.email.content.start')) + " ", 1 /* TEXT */),
          _createElementVNode("dsf-link", {
            dsf_href: `mailto:{${email}}`
          }, _toDisplayString(email), 8 /* PROPS */, _hoisted_6),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('helpCenter.email.content.end')), 1 /* TEXT */)
        ]),
        _createElementVNode("dsf-text", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('helpCenter.survey.content.start')) + " ", 1 /* TEXT */),
          _createElementVNode("dsf-link", { dsf_href: feedbackLink }, _toDisplayString(_ctx.$t('helpCenter.survey.title')), 1 /* TEXT */),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('helpCenter.survey.content.end')), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("dsf-text", _hoisted_8, _toDisplayString(_ctx.$t('helpCenter.title')), 1 /* TEXT */),
        _createElementVNode("dsf-text", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.$t('helpCenter.email.content.start')) + " ", 1 /* TEXT */),
          _createElementVNode("dsf-link", {
            dsf_href: `mailto:{${email}}`,
            dsf_size: "medium"
          }, _toDisplayString(email), 8 /* PROPS */, _hoisted_10),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('helpCenter.email.content.end')), 1 /* TEXT */)
        ]),
        _createElementVNode("dsf-text", _hoisted_11, [
          _createTextVNode(_toDisplayString(_ctx.$t('helpCenter.survey.content.start')) + " ", 1 /* TEXT */),
          _createElementVNode("dsf-link", {
            dsf_href: feedbackLink,
            dsf_size: "medium"
          }, _toDisplayString(_ctx.$t('helpCenter.survey.title')), 1 /* TEXT */),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('helpCenter.survey.content.end')), 1 /* TEXT */)
        ])
      ])
    ])
  ], 32 /* HYDRATE_EVENTS */))
}
}

})